// Notifications.jsx
import { useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Bell, CheckCheck } from 'lucide-react';
import { api, timeAgo } from '../lib/api';
import { useAuth } from '../lib/store';
import { SkeletonList, Empty, SectionHead } from '../components/ui';

const ICON = {
  purchase: '💎', referral: '🤝', fight: '⚔️', fight_invite: '🗡️', levelup: '⭐',
  offer: '🔥', rating: '⭐', shop_status: '🏪', shop_pending: '📋', guild: '🛡️',
  daily: '🎁', welcome: '🎉', broadcast: '📢', comment: '💬', admin: '🛠️',
};

export default function Notifications() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ['notifs'], queryFn: () => api.get('/notifications').then(r => r.data) });
  const readAll = useMutation({ mutationFn: () => api.post('/notifications/read'), onSuccess: () => { qc.invalidateQueries(['notifs']); useAuth.getState().setUnread(0); } });

  useEffect(() => { readAll.mutate(); }, []);

  return (
    <div className="space-y-3 animate-fade-up">
      <SectionHead title="Notifications" right={
        <button onClick={() => readAll.mutate()} className="btn-ghost btn-sm"><CheckCheck size={13} /> Mark all</button>} />
      {isLoading ? <SkeletonList n={6} h="h-16" />
        : !data?.length ? <Empty icon={Bell} title="All caught up!" sub="Notifications about points, offers and duels appear here." />
        : <div className="card p-2 space-y-1">
          {data.map(n => (
            <Link key={n.id} to={n.link || '#'}
              className={`flex items-start gap-3 p-3 rounded-xl hover:bg-ink-50 ${!n.is_read ? 'bg-brand-50/60' : ''}`}>
              <span className="text-xl shrink-0">{ICON[n.type] || '🔔'}</span>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-sm">{n.title}</p>
                {n.body && <p className="text-xs text-ink-500 mt-0.5">{n.body}</p>}
                <p className="text-[10px] text-ink-400 font-semibold mt-1">{timeAgo(n.created_at)}</p>
              </div>
              {!n.is_read && <span className="w-2 h-2 rounded-full bg-brand-500 mt-1.5" />}
            </Link>))}
        </div>}
    </div>
  );
}